import initElecTestDrive  from './initElecTestDrive';

const electricTestDrive = document.querySelectorAll('.cms-content-slice-electric-test-drive');
const electricTestDriveLength = electricTestDrive.length;
if (electricTestDriveLength > 0) {
    for (let index = 0; index < electricTestDriveLength; index++) {
        initElecTestDrive (electricTestDrive[index]);
    }
}
